<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <!-- the image collections' one header (PageHeader.vue; 2026-10-26) -->
  <PageHeader title="Photos" to="/Photos" :count="photoCount" :total="photoTotal">
    <Dropdown chevron placeholder="Year" :options="years" :selected="year" @update="setYearHere" />
  </PageHeader>
</template>

<script>
// https://medium.com/@magyarn/simple-photo-app-with-vue-js-axios-and-flickr-api-part-1-e6e84bfe2580
import Dropdown from "@/components/Dropdown";
import PageHeader from "@/components/PageHeader.vue";
export default {
  name: "Photos",
  components: {Dropdown, PageHeader},
  props: {
    totalPhotos: {type: Number, default: 0},
    years: {type: Array, default: () => []},
    photoDataByYear: {type: Object, default: () => {}}
  },
  emits: ["setYear"],
  data() {
    return {
      year: this.$route.params.photoYear || "" // empty string = all years
    };
  },
  computed: {
    // the year's photos of all, or all
    photoCount() {
      if (!this.totalPhotos) return "";
      const yearPhotos = this.year && this.photoDataByYear?.[this.year];
      return yearPhotos ? yearPhotos.length : this.totalPhotos;
    },
    // all the photos beside one year's ("[212/3,456]")
    photoTotal() {
      const isYear = this.year && this.photoDataByYear?.[this.year];
      return this.totalPhotos && isYear ? this.totalPhotos : "";
    }
  },
  methods: {
    // eslint-disable-next-line
    log(message) {
      if (process.env.NODE_ENV === "development") {
        console.log(message); // uncomment to show logs from this component
      }
    },
    setYearHere(year) {
      this.log(`change selected year to: ${year}`);
      if (typeof year === "string") {
        history.pushState({}, null, `/Photos/${year}`);
        this.year = year;
      } else {
        // showAll button returns a push event
        history.pushState({}, null, `/Photos/`);
        this.year = "";
      }
      this.$emit("setYear", this.year);
    }
  }
};
</script>
